export function buildOptionVoteCounts(options) {
  const counts = {};
  for (const option of Array.isArray(options) ? options : []) {
    const optionId = String(option?.id || "");
    if (!optionId) continue;
    counts[optionId] = normalizeVoteCount(option?.votes);
  }
  return counts;
}

export function getIncreasedOptionIds(previousCounts, nextOptions) {
  const prev = previousCounts && typeof previousCounts === "object" ? previousCounts : {};
  const increased = [];
  const options = Array.isArray(nextOptions) ? nextOptions : [];

  for (const option of options) {
    const optionId = String(option?.id || "");
    if (!optionId) continue;
    const prior = prev[optionId];
    if (typeof prior !== "number") continue;
    const current = normalizeVoteCount(option?.votes);
    if (current > prior) {
      increased.push(optionId);
    }
  }
  return increased;
}

function normalizeVoteCount(value) {
  const count = Number(value);
  if (!Number.isFinite(count)) return 0;
  if (count < 0) return 0;
  return count;
}
